module.exports = __webpack_public_path__ + "img/local_img.813aed23.png";